import { Box, FormControl, MenuItem, Switch, TextField, Typography } from '@mui/material';
import type { TextFieldProps } from '@mui/material/TextField';
import { alpha, styled, useTheme } from '@mui/material/styles';
import React from 'react';

export const TypographyForms = propsTypographyForms => {
  const theme = useTheme();
  return (
    <Typography {...propsTypographyForms} sx={{ color: theme.palette.text.primary, fontWeight: '600' }}>
      {propsTypographyForms.children}
    </Typography>
  );
};

export const BoxForm = propsBoxForm => (
  <Box {...propsBoxForm} component={'form'} sx={{ display: 'flex', flexDirection: 'column' }}>
    {propsBoxForm.children}
  </Box>
);

export const FormControlDefault = propsFormControlDefault => (
  <CustomFormControl {...propsFormControlDefault}>{propsFormControlDefault.children}</CustomFormControl>
);

export const CustomFormControl = styled(FormControl)(({ theme }) => ({
  margin: '10px 0px 10px 0px ',
}));

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  maxHeight: '200px',
  overflow: 'auto',
}));

export const CustomTextField = styled(TextField)<TextFieldProps>(({ theme, multiline }) => ({
  height: multiline ? 'auto' : '43px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    height: multiline ? 'auto' : '100%',
    '&.Mui-focused fieldset': {
      border: `1px solid ${theme.palette.secondary.main}`,
    },
  },
  '& .MuiFormControl-root.MuiTextField-root': {
    '&:hover': {
      borderColor: theme.palette.secondary.main,
    },
  },
  '& fieldset': {
    top: '0',
    '& legend': {
      display: 'none',
    },
  },
  '& .MuiInputBase-input': {
    padding: '10px 16px',
    color: theme.palette.text.primary,
  },
}));

export const TextFieldForms = ({ ...propsTextFieldForms }) => {
  const theme = useTheme();
  return (
    <CustomTextField
      {...propsTextFieldForms}
      sx={{ ...propsTextFieldForms?.sx, color: theme.palette.text.primary }}
      inputProps={{ ...propsTextFieldForms?.inputProps, style: { ...propsTextFieldForms?.style, borderRadius: '8px', color: theme.palette.text.primary } }}
      InputLabelProps={{
        shrink: true,
      }}
      variant="outlined"
      SelectProps={{
        ...propsTextFieldForms.SelectProps,
        MenuProps: {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          PaperProps: {
            style: {
              maxHeight: 200,
              width: 'auto',
            },
          },
        },
      }}
    >
      {...propsTextFieldForms.children}
    </CustomTextField>
  );
};

export const BoxImg = styled('img')(({ theme }) => ({
  bordeRadius: '15px 15px 0 0',
  width: '100%',
  height: '180px',
  borderRadius: '8px',
  padding: '5px',
  border: `1px solid ${theme.palette.secondary.main}`,
  margin: '15px 0px',
}));

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: theme.palette.secondary.main,
  },
}));